import { useTranslations } from '@vocab/react';
import { IconTick, Stack, Text } from 'braid-design-system';

import translations from './.vocab';

export const AIContentGenerationComplete = () => {
  const { t } = useTranslations(translations);

  return (
    <Stack
      space="large"
      align="center"
      data-testid="ai-content-generation-complete"
    >
      {/* To be replaced with the actual image */}
      <IconTick />
      <Stack space="small" align="center">
        <Text weight="strong" size="small">
          {t('job-content-generation-success-heading')}
        </Text>
        <Text size="small">{t('job-content-generation-success-text')}</Text>
      </Stack>
    </Stack>
  );
};
